import React from "react";
import { H2, Text } from "@shoptet/ui";
import { useTranslation } from "react-i18next";

type CampaignType = "google" | "meta";

interface DetailsBoxProps {
  campaignType: CampaignType;
  color: string;
  metricLabel?: string;
  value: string;
}

const DetailsBox: React.FC<DetailsBoxProps> = ({ campaignType, color, metricLabel, value }) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.Stats" });

  const campaignLabel = campaignType === "google" ? t("Google campaigns") : t("Meta campaigns");
  const displayValue = metricLabel ? `${metricLabel}: ${value}` : value;

  return (
    <div
      style={{ flex: 1, padding: "16px", border: "1px solid var(--app-border)", borderRadius: "var(--app-radius-box)" }}
    >
      <H2 divider={false}>
        <span style={{ color }}>{displayValue}</span>
      </H2>
      <Text appearance="lg">{campaignLabel}</Text>
    </div>
  );
};

export default DetailsBox;
